<template>
	<div 
		class="pxrwwfgv-drop-spot"
		ref="dropspotel"
		:class="dropSpotClasses"
		:style="dropSpotStyle"
		:data-id="dropSpot.id"
		@click="selectDropSpot"
	>
		<div class="pxrwwfgv-drop-spot-inner">
			<div class="pxrwwfgv-remove-intervention" @click="removePlacedIntervention" v-if="!showSolve"><wwf-icon name="back" :size="10" color="#fff" /></div>
		</div>
	</div>
</template>

<script setup >
	import {ref, defineProps, computed, watch} from 'vue';
	import { useMouseInElement } from '@vueuse/core';
	import {useStore} from 'vuex';

	import WwfIcon from "@/components/ui/WwfIcon.vue";

	const props = defineProps({
		showSolve: {
			type: Boolean,
			default: false,
		},
		dropSpot: {
			default: null,
		},
	});
	const store = useStore();

	const dropspotel = ref(null);
	const {isOutside} = useMouseInElement(dropspotel);

	const placedIntervention = computed(() => {
		return store.getters['spotPlacedIntervention'](props.dropSpot.id)
	});

	const accepting = computed(() => {
		return !isOutside.value && store.getters['inDrag'] && !placedIntervention.value
	});

	const dropSpotClasses = computed(() => {
		if(props.showSolve) return {'-placed': true, '-solve': true};

		return {
			'-accepting': accepting.value,
			'-placed': placedIntervention.value,
			'-selected': placedIntervention.value && store.getters.selectedDropSpot && store.getters.selectedDropSpot.id == props.dropSpot.id,
		};
	});

	const dropSpotStyle = computed(() => {
		let style = {
			left: props.dropSpot.coords[0]+'px',
			top: props.dropSpot.coords[1]+'px',
		};

		if(props.showSolve){
			let solveIntervention = store.getters.interventions.find((iv) => {
				return iv.correctLocations[0] === props.dropSpot.id;
			});

			if(!solveIntervention){
				solveIntervention = store.getters.interventions.find((iv) => {
					return iv.correctLocations.includes(props.dropSpot.id);
				});
			}

			if(solveIntervention){
				style.backgroundImage = 'url(\''+solveIntervention.thumbnail+'\')';
			}
		}
		else {
			if(placedIntervention.value){
				style.backgroundImage = 'url(\''+placedIntervention.value.intervention.thumbnail+'\')';
			}
		}
		
		return style;
	});

	watch(accepting, () =>{
		store.dispatch('setAcceptingDropSpot', ((accepting.value)? props.dropSpot : null));
	});

	//select
	function selectDropSpot(){
		if(!placedIntervention.value){
			return;
		}

		store.dispatch('setDrawerOpen', true);
		store.dispatch('setSelectedDropSpot', props.dropSpot);
	}

	//remove placed
	function removePlacedIntervention(){
		store.dispatch('removePlacedIntervention', props.dropSpot.id);
	}
</script>

<style scoped>
	.pxrwwfgv-drop-spot {
		position: absolute;
		z-index: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 73px;
		height: 73px;
		border-radius: 100%;

		background-color: #fff;
		background-size: contain;
		background-position: 50% 50%;
		background-repeat: no-repeat;
		border: 4px solid #000;
		
		opacity: 0.3;
		transition: all 300ms ease-out;
	}
	.pxrwwfgv-drop-spot.-accepting {
		opacity: 0.7;
		transform: scale(2);
		border-width: 2px;
	}
	.pxrwwfgv-drop-spot.-placed {
		opacity: 1;
		transform: scale(1.8);
		border-color: transparent;
		background-color: transparent;

		cursor: pointer;
	}
	.pxrwwfgv-drop-spot.-solve {
		cursor: default;
	}

	.pxrwwfgv-drop-spot.-placed::before {
		content: '';
		display: block;
		position: absolute;
		z-index: 2;
		pointer-events: none;
		width: calc(100% + 10px);
		height: calc(100% + 10px);
		border-radius: 100%;

		border: 0px solid #fff;
		opacity: 0;
		transform: scale(1.5);
		transition: all 300ms ease-out;
	}
	.pxrwwfgv-drop-spot.-placed.-selected::before {
		border-width: 5px;
		opacity: 1;
		transform: scale(0.95);
	}

	.pxrwwfgv-drop-spot-inner {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.pxrwwfgv-remove-intervention {
		position: absolute;
		z-index: 3;
		top: -4px;
		right: -4px;
		width: 20px;
		height: 20px;
		background-color: red;
		color: #fff;
		border-radius: 100%;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;

		opacity: 0;
		visibility: hidden;
		transition: opacity 300ms ease-out;
	}
	.pxrwwfgv-drop-spot.-placed:hover .pxrwwfgv-remove-intervention,
	.pxrwwfgv-drop-spot.-selected .pxrwwfgv-remove-intervention {
		opacity: 1;
		visibility: visible;
	}
</style>